import Fiel from '@/models/Fiel'
import fielService from '@/modules/signers/services/fielService'

export default {
  namespaced: true,
  state: () => ({
    fiel: null,
    isValidOcsp: false,
    isValidRootCertificates: false,
    isValid: false,
    errorMessage: '',
    onSuccessFiel: null,
    clean: false,
    rfcToCompare: null
  }),
  mutations: {
    SET_FIEL(state, fiel) {
      state.fiel = fiel
    },
    SET_VALID_OCSP(state, isValid) {
      state.isValidOcsp = isValid
    },
    SET_VALID_ROOT_CERTIFICATES(state, isValid) {
      state.isValidRootCertificates = isValid
    },
    SET_VALID(state, isValid) {
      state.isValid = isValid
    },
    SET_ERROR_MESSAGE(state, errorMessage) {
      state.errorMessage = errorMessage
    },
    SET_ON_SUCCESS_FIEL(state, callback) {
      state.onSuccessFiel = callback
    },
    SET_CLEAN(state, clean) {
      state.clean = clean
    },
    SET_RFC_TO_COMPARE(state, rfc) {
      state.rfcToCompare = rfc
    }
  },
  actions: {
    async validateFiel(
      { commit },
      { csd, key, password, csdFile, rfcToCompare }
    ) {
      return new Promise(resolve => {
        const fiel = new Fiel(csd, key, password, rfcToCompare)
        let isValid = fiel.validate()

        if (isValid) {
          fiel.certificateFile = csdFile
          const service = new fielService(fiel)

          service
            .validateRootCertificates()
            .then(({ data }) => {
              isValid = data.success
              commit('SET_VALID_ROOT_CERTIFICATES', isValid)
              commit('SET_VALID', isValid)

              if (isValid) {
                commit('SET_FIEL', fiel)
              } else {
                commit('SET_FIEL', null)
                commit('SET_ERROR_MESSAGE', data.error.message)
              }

              resolve(isValid)
            })
            .catch(err => {
              let errorMessage = ''
              if (err.response == undefined || err.response.status === 500) {
                errorMessage =
                  'Ocurrio un error. El servidor no pudo realizar la validación.'
              } else {
                errorMessage = err.response.data.error.message
              }
              commit('SET_ERROR_MESSAGE', errorMessage)
              resolve(false)
            })
        } else {
          commit('SET_ERROR_MESSAGE', fiel.errorMessage)
          resolve(false)
        }
      })
    },
    setOnSuccessFiel({ commit }, callback) {
      commit('SET_ON_SUCCESS_FIEL', callback)
    },
    resetFiel({ commit }) {
      commit('SET_FIEL', null)
      commit('SET_VALID_OCSP', false)
      commit('SET_VALID_ROOT_CERTIFICATES', false)
      commit('SET_VALID', false)
      commit('SET_CLEAN', true)
      commit('SET_RFC_TO_COMPARE', null)
    },
    cleaned({ commit }) {
      commit('SET_CLEAN', false)
    },
    setFielRfcToCompare({ commit }, rfc) {
      commit('SET_RFC_TO_COMPARE', rfc)
    }
  },
  getters: {
    fiel(state) {
      return state.fiel
    },
    fielErrorMessage(state) {
      return state.errorMessage
    },
    onSuccessFiel(state) {
      return state.onSuccessFiel
    },
    clean(state) {
      return state.clean
    },
    rfcToCompare(state) {
      return state.rfcToCompare
    }
  }
}
